import { render, staticRenderFns } from "./bookInfo.vue?vue&type=template&id=0fcf1d58&scoped=true"
import script from "./bookInfo.vue?vue&type=script&lang=js"
export * from "./bookInfo.vue?vue&type=script&lang=js"
import style0 from "./bookInfo.vue?vue&type=style&index=0&id=0fcf1d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf1d58",
  null
  
)

export default component.exports